import styles from "./AssetFeatureTags.module.scss";
import EditAttachment from "../../icons/EditAttachment.tsx";
import MiscellaneousAccessibility from "../../icons/MiscellaneousAccessibility.tsx";
import { useIntl } from "react-intl";
import { clsx } from "clsx";
import {
  License,
  ManageAsset,
} from "../../api/decimal/common-types/manageAssets.ts";

export default function AssetFeatureTags({
  asset,
  license,
  className,
  actions,
}: {
  asset: ManageAsset;
  license?: License;
  className?: string;
  actions?: {
    openAncillariesPanel?: () => void;
    openAccessibilityPanel?: () => void;
  };
}) {
  const intl = useIntl();
  const hasAncillaries = asset.ancillaries.length > 0;
  const expired = license ? license.expired : false;
  const additionalFeatures = [
    {
      label: intl.formatMessage({ defaultMessage: "Ancillaries" }),
      ariaLabel: intl.formatMessage(
        { defaultMessage: "View Ancillaries for {title}" },
        { title: asset.title }
      ),
      icon: <EditAttachment height={10} />,
      enabled: hasAncillaries && !expired,
      onClick: actions?.openAncillariesPanel,
    },
    {
      label: intl.formatMessage({ defaultMessage: "Accessibility Claims" }),
      ariaLabel: intl.formatMessage(
        { defaultMessage: "View Accessibility Claims for {title}" },
        { title: asset.title }
      ),
      icon: <MiscellaneousAccessibility height={10} />,
      // TODO once work is complete in decimal will need to add
      // condition to check if asset has accessibility claims
      // VST-87223 - remove tag until manage work is complete
      enabled: false,
      onClick: actions?.openAccessibilityPanel,
    },
  ].filter((el) => el.enabled);

  if (additionalFeatures.length === 0) {
    return null;
  }

  return (
    <div className={clsx(styles.tags, className)}>
      {additionalFeatures.map((tag) => {
        const Tag = tag.onClick ? "button" : "div";
        return (
          <Tag
            className="vst-mini-tag"
            key={tag.label}
            onClick={tag.onClick}
            aria-label={tag.ariaLabel}
          >
            {tag.icon}
            {tag.label}
          </Tag>
        );
      })}
    </div>
  );
}
